import { EmailSettingsModel } from "@app/api2/api";
import * as yup from "yup";

export const AppSettingsSchema: yup.SchemaOf<EmailSettingsModel> = yup.object().shape({

    fromName: yup.string().required(),
    emailProvider: yup.string().required(),
    fromEmail: yup.string().email().required(),
    host: yup.string().when("emailProvider", (userType, schema) => {
        if (userType === "Smtp") {
            return schema.required()
        } else {
            return schema.nullable();
        }
    }),
    port: yup.number().when("emailProvider", (userType, schema) => {
        if (userType === "Smtp") {
            return schema.required()
        } else {
            return schema.nullable();
        }
    }),
    username: yup.string().optional().nullable(),
    password: yup.string().optional().nullable(),
    useSsl: yup.boolean().optional(),
    sendGridApiKey: yup.string().when("emailProvider", (userType, schema) => {
        if (userType === "SendGrid") {
            return schema.required()
        } else {
            return schema.nullable();
        }
    }),
    azureCommServiceEndpoint: yup.string().when("emailProvider", (userType, schema) => {
        if (userType === "AzureEmailComm") {
            return schema.required()
        } else {
            return schema.nullable();
        }
    }),
    populationFrequencyMaxError: yup.number().min(0).max(1),
    requestAccessUrl: yup.string().url().optional().nullable(),
    searchInAllLabs: yup.bool(),
    runTypes: yup.array(),
    secondaryParametersCollapsed: yup.boolean(),
    openAiApiKey: yup.string().optional().nullable(),
    openAiEpgPrompt: yup.string().optional().nullable(),
    openAiModel: yup.string().optional().nullable(),
    locales: yup.array().of(yup.object({
        code: yup.string().required(),
        name: yup.string().required(),
        isEnabled: yup.boolean().required(),
        siteDefault: yup.boolean().required(),
        localizedName: yup.string().required(),
    })).required(),
    autoscaleFormula: yup.string().optional().required(),
    // allowSamplesFromOtherCases: yup.boolean()
});